import React from "react";
import classNames from "classnames";

import { ScreenWatcher } from "@common/screenWatcher";
import { LayoutWatcher } from "@common/layoutWatcher";
import { ActivityWatcher } from "@common/activityWatcher";
import { Props } from "./types";
import { ArrowIcon } from "./arrowIcon";
import { List } from "./list";
import styles from "./styles.scss";

function ListSelect({ lists, selectedList, filteredLists, selectList }: Props) {
  const [isOpen, setIsOpen] = React.useState(false);
  const toggle = () => setIsOpen(!isOpen);

  return (
    <ActivityWatcher blur={() => isOpen && toggle()}>
      <div
        className={classNames(styles.selectList, {
          [styles.opened]: isOpen,
        })}
      >
        <div className={styles.input} onClick={toggle}>
          <ul className={styles.selectedItems}>
            {selectedList && (
              <li className={styles.selectedItem}>{selectedList.name}</li>
            )}
          </ul>
          <div className={styles.iconBox}>
            <ArrowIcon className={styles.icon} />
          </div>
        </div>
        {isOpen && (
          <ScreenWatcher
            renderChildren={({ height }) => (
              <LayoutWatcher
                className={styles.layoutWatcher}
                renderChildren={({ top }) => {
                  const maxHeight = height - top - 60;

                  return (
                    <ul
                      className={styles.list}
                      style={{
                        maxHeight: `${
                          maxHeight < 320 && maxHeight > 100 ? maxHeight : 320
                        }px`,
                      }}
                    >
                      {[...lists]
                        .sort((current, next) =>
                          current.activityKeyRank < next.activityKeyRank
                            ? -1
                            : 1,
                        )
                        .map((list) => (
                          <li key={list.uuid} className={styles.item}>
                            <List
                              list={list}
                              selectedList={selectedList}
                              filteredLists={filteredLists}
                              selectList={(list) => {
                                selectList(list);
                                toggle();
                              }}
                            />
                          </li>
                        ))}
                    </ul>
                  );
                }}
              />
            )}
          />
        )}
      </div>
    </ActivityWatcher>
  );
}

export { ListSelect };
